function achivementMapping(data={}, index) {   
  let rowData = {
    key: index, 
    awnoID: data.AW_NO_ID ? data.AW_NO_ID : false,  
    show: data.IS_SHOW ? data.IS_SHOW : false,
    title: data.AW_NAME ? data.AW_NAME : null,
    year: data.END_YEAR ? data.END_YEAR : null,
    journal: data.JOURNAL_NAME ? data.JOURNAL_NAME : null,
    volumn: data.VOLUMN ? data.VOLUMN : null,
    start_page: data.START_PAGE ? data.START_PAGE : null,
    end_page: data.END_PAGE ? data.END_PAGE : null
  }
  rowData.yearEN = rowData.awnoID ? convertYear(rowData) : null

  return rowData


}
function convertYear(value)
{
   if(value.year!=null)
      return (value.year-543)
  else return null


}
export default achivementMapping
